import type { LandmarkDef } from './common';
import { landmarkModel, windowGlass } from './model';

/**
 * landmarks/mumbai.ts — Mumbai's landmarks, all hand-built low-poly Blender models
 * (glTF). The Gateway of India is a drive-through ('span') scaled by width.
 */
export const MUMBAI_LANDMARKS: Record<string, LandmarkDef> = {
  cst: { build: () => landmarkModel('models/landmarks/cst.glb', { height: 32 }), placement: 'side', offset: 13 },
  seaLink: { build: () => landmarkModel('models/landmarks/sea_link.glb', { height: 30 }), placement: 'side', offset: 130 },
  // GS6: day city — the full-wall 'win' slabs become dark tinted glass
  // (windowGlass, the Apollo recipe). Both models still owe the Mumbai
  // Blender round their window RE-CUTS (the slabs are geometry-large); these
  // entries survive that rebuild via this def.
  hajiAliDargah: { build: () => landmarkModel('models/landmarks/haji_ali_dargah.glb', { height: 18, ...windowGlass('win', 0.45) }), placement: 'side', offset: 36 },
  // M97: pushed off the rail (the wide facade loomed over the final approach)…
  tajHotel: { build: () => landmarkModel('models/landmarks/taj_hotel.glb', { height: 32, ...windowGlass('win', 0.45) }), placement: 'side', offset: 18 },
  // Mumbai round: the finish hero is now a real photogrammetry scan (CC-BY,
  // see public/models/landmarks/CREDITS.md) — pointed central arch, four
  // corner turrets, cornice bands, warm yellow basalt with its own baked
  // textures (hence skipTexturing). Blender surgery: maquette plinth stripped,
  // the central arch bay STRETCHED (piecewise X remap — flanks translate
  // rigidly, only the arch bay widens) so the road fits through, depth
  // compressed 0.6x so the monument doesn't swallow the finish plaza.
  // MEASURED: the arch opening is 43.7% of the model's total width, so
  // width = (2*hw + 4) / 0.4366 keeps ~2u of visual clearance outside each
  // guardrail (hw=18 -> total 92 wide, 45 tall, opening 40 over a 36 road).
  gatewayOfIndia: {
    build: (hw) =>
      landmarkModel('models/landmarks/gateway_of_india.glb', {
        width: (2 * hw + 4) / 0.4366,
        skipTexturing: true,
      }),
    placement: 'span',
  },
};
